// @ts-ignore
// @ts-nocheck
import React, { useState, useEffect } from 'react'
import { Spinner } from 'react-bootstrap'
import Modal from '../../modal/Modal'
import { getStatusById } from '../../utlis/utlis'

interface CashFreeProps {
  payload: any
 
}

const CashFree: React.FC<CashFreeProps> = (props) => {
  const { payload } = props
  const [loading, setLoading] = useState<boolean>(false)
  const [modalShow, setModalShow] = useState<boolean>(false)
  console.log({payload})

  useEffect(() => {
    if (payload?.sessionId) {
      setModalShow(true)
    } else {
      console.error('Order session ID is missing.')
      transactionStatusCallback({
        message: 'Order session ID is missing',
        status: 'FAILED',
      })
    }
  }, [payload])

  useEffect(() => {
    setTimeout(()=>{

      handleOpenCashFreeMode()
    },2000)
  }, [])

  const handleOpenCashFreeMode = () => {
    const windowCashfree: any = window
    if (!windowCashfree.Cashfree) {
      console.error('Cashfree script is not loaded.')
      return
    }

    setLoading(true)

    try {
      const cashfree = windowCashfree.Cashfree({ mode: payload.mode })
      const checkoutOptions = {
        paymentSessionId: payload?.sessionId || '',
        redirectTarget: '_self',
        // order_meta: {
        //   // return_url: `https://dev-ks-pay-openapi.p2eppl.com/webhook/cashfree/order?order_id=${payload?.pe_txnId}`,
        //   return_url: `http://localhost:3000/success/?order_id=${payload?.pe_txnId}`,

        // },
      }
console.log({checkoutOptions})
      cashfree.checkout(checkoutOptions)
      // .then((res:any)=>{

        // const result = await getStatusById(txId, headers)
  //     const response = result?.data?.result
  //     if (response) {
  //       // transactionStatusCallback({ txId, status: response?.status })
  //     }
  //   } catch (err) {
  //     console.error({ err })
  //     // transactionStatusCallback({ txId, status: 'PENDING' })
  //   }

      // })
    } catch (error) {
      console.error('Error opening Cashfree checkout:', error)
    } finally {
      setLoading(false)
      setModalShow(false)
    }
  }

  const handleHideModal = () => {
    callAfterPayment(false)
    setModalShow(false)
  }

  return (
    <>
      {/* {modalShow && (
        <Modal title={'Complete Payment'} onHide={handleHideModal}>
          <button className='cash-free-btn' onClick={handleOpenCashFreeMode} disabled={loading || !payload?.sessionId}>
            {loading ? (
              <>
                <Spinner animation='border' size='sm' /> Open Cashfree Checkout
              </>
            ) : (
              'Open Cashfree Checkout'
            )}
          </button>
        </Modal>
      )} */}
    </>
  )
}

export default CashFree
